export default __webpack_public_path__ + "static/media/book.df367397.jpg";